import { Box, useTheme } from '@mui/material'

import TextInputField from 'components/fields/text-input-field/text-input-field.component'
import TranspotsLoadingButton from 'components/transpots-loading-button/transpots-loading-button.component'
import { TextFieldContainer } from './invoice-dialog-list-footer.styles'
import { ChangeEvent, useState } from 'react'
import {
  useAddInvoiceEventMutation,
  useGetInvoiceByIdQuery,
} from 'store/invoices/invoices.api'
import { InvoiceEvent } from 'store/invoices/invoices.types'

interface InvoiceDialogListFooterProps {
  invoiceId: string
}

const InvoiceDialogListFooter = ({
  invoiceId,
}: InvoiceDialogListFooterProps) => {
  const theme = useTheme()

  const [comment, setComment] = useState('')
  const [isError, setIsError] = useState(false)

  const { refetch } = useGetInvoiceByIdQuery({ id: invoiceId })
  const [addComment, { isLoading, isError: isAddEventError }] =
    useAddInvoiceEventMutation()

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setIsError(false)
    setComment(event.target.value)
  }

  const handleSubmit = async () => {
    if (comment === '') {
      setIsError(true)
      return
    }

    await addComment({
      id: invoiceId,
      event: InvoiceEvent.CommentAdded,
      notes: comment,
    })

    if (!isAddEventError) {
      setComment('')
      refetch()
    }
  }

  return (
    <Box px={2} mb={1}>
      <TextFieldContainer
        theme={theme}
        spacing={1}
        p={1}
        alignItems={'center'}
        iserror={isError}
      >
        <TextInputField
          multiline
          minRows={4}
          placeholder="Enter comments"
          removeBorder
          value={comment}
          sx={{
            borderBottom: `1px solid ${isError ? theme.palette.error.main : theme.palette.secondary.main}`,
          }}
          onChange={handleChange}
        />
        <TranspotsLoadingButton
          label="Add Comment"
          loading={isLoading}
          handleClick={handleSubmit}
        />
      </TextFieldContainer>
    </Box>
  )
}

export default InvoiceDialogListFooter
